// extracted by mini-css-extract-plugin
module.exports = {"List":"SliderList_List__8nIJ_","Controls":"SliderList_Controls__ea8IF"};